---
title: Trace Code Back to Agent Sessions
description: Tokyo summit week brought Entire CLI 0.7.6 with experimental entire blame and entire why commands, plus Entire Web reliability fixes.
category: Changelog
author: Marvin
---

Beep, boop. Dispatch 0x0012 has arrived.

We're a remote-first company, but twice a year we bring the whole team together to align, plan, and remember that our coworkers are not merely pixels with calendar invites. This week, about 32 Entirons gathered in Tokyo for our team summit to build a unified path forward together.

In between summit sessions and recovering from a turbulent amount of jet lag, we shipped fixes across the [Entire CLI](https://github.com/entireio/cli) and [Entire Web](https://entire.io/).

![Entire team gathered outdoors during the Tokyo summit](/blog/entire-dispatch-0x0012/dispatch-0x0012-tokyo.jpg)

## Entire CLI

_Released via [v0.7.6](https://github.com/entireio/cli/releases/tag/v0.7.6). For changes that have not reached stable yet, nightly releases are available; installation instructions are [here](https://docs.entire.io/cli/installation)._

### New Experimental Commands

- `entire blame` and `entire why` are now available in labs as experimental commands. They trace specific lines of code back to the checkpoints and sessions that touched them, making it easier to review AI-authored code.
  - Thank you, [@suhaanthayyil](https://github.com/suhaanthayyil), for your contribution!

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.67065868263472%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/ab2d696d319f2f9d1643c9e57f8132a2/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2Fab2d696d319f2f9d1643c9e57f8132a2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Entire blame demo"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.67065868263472%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/a59bddb595f22b2eab38e0200d42a4a8/iframe?muted=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2Fa59bddb595f22b2eab38e0200d42a4a8%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
    title="Entire why demo"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

### Deprecating Rewind

- `entire checkpoint rewind` is now deprecated ahead of removal in a future release and no longer appears in help or shell completions. It remains functional for now, but we recommend using your agent's native rollback flow where available.

## Entire Web

### UI Polish

- Native scrollbars now respect your Light, Dark, or Auto theme setting, so scrollable areas feel consistent with the rest of the UI.

### Reliability

- Fixed branch comparisons that could fail because git fetches were using the wrong GitHub credentials. The compare view now fetches refs with the repository's installation token.
- Fixed cases where the app showed "Repository not found" for failures that were not missing-repository errors.

That'll do it for this week. As always, keep your questions, bugs, PRs, and feedback coming in [Discord](https://discord.com/invite/jZJs3Tue4S) or [GitHub issues](https://github.com/entireio/cli/issues).

Boop.
